import * as yup from "yup";

export const filterAssignmentValidationSchema = yup.object({
  filter: yup
    .mixed().nullable().optional(),
  columnSet: yup
    .mixed().nullable().optional(),
  groups: yup
    .array()
    .min(1, "At least one group is required")
    .required("Groups are required")
    .nullable(),
}).test(
  "filter-or-columnSet-required",
  "At least one of Filter or Column Set must be selected",
  function (value) {
    return !!(value?.filter || value?.columnSet);
  }
);
